import Header from "@/components/layout/headers/Header";
import Footer from "@/components/layout/footers/Footer";
import ClientProviders from '@/components/shared/wrappers/ClientProviders';

export default function PageWrapper({
    children,
    catalogPage,
    miniCatalogPage,
    headerStyle,
    headerSize,
    navBg,
    footerBg,
    commonData,
    userData,
    categories,
    brands,
    filterMenu
}) {
  return (
      <>
        <div className="body-wrapper">
          <ClientProviders
              commonData={commonData}
              userData={userData}
          >
            <Header
                data={commonData}
                headerStyle={headerStyle}
                headerSize={headerSize}
                navBg={navBg}
                categories={categories}
                brands={brands}
                catalogPage={catalogPage}
                filterMenu={filterMenu}
                miniCatalogPage={miniCatalogPage}
            />
            {children}
            <Footer
                home={commonData?.home}
                footerBg={footerBg}
            />
          </ClientProviders>
          {/*<Preloader/>*/}
        </div>
      </>
  );
};
